window.addEventListener("DOMContentLoaded", function () {
    let noshiSelect = document.getElementById("noshi");
    let noshiOmote = document.getElementById("NoshiOmoteWrap");
    let noshiOmoteSonota = document.getElementById("NoshiOmoteSonotaWrap");
    let noshiOkurinushi = document.getElementById("NoshiOkurinushiWrap");
    let noshiOmoteSelect = document.getElementById("NoshiOmote");

    if (noshiSelect.value === "希望しない" || noshiSelect.value === "") {
        noshiOmote.style.display = "none";
        noshiOmoteSonota.style.display = "none";
        noshiOkurinushi.style.display = "none";
    }

    noshiSelect.addEventListener("change", function () {
        if (noshiSelect.value === "希望する") {
            noshiOmote.style.display = "block";
            noshiOmoteSonota.style.display = "block";
            noshiOkurinushi.style.display = "block";

            noshiOmoteSelect = document.getElementById("NoshiOmote");
            if (noshiOmoteSelect.value !== "その他") {
                noshiOmoteSonota.style.display = "none";
            }

            noshiOmoteSelect.addEventListener("change", function () {
                if (noshiOmoteSelect.value === "その他") {
                    noshiOmoteSonota.style.display = "block";
                } else {
                    noshiOmoteSonota.style.display = "none";
                }
            });
        } else {
            noshiOmote.style.display = "none";
            noshiOmoteSonota.style.display = "none";
            noshiOkurinushi.style.display = "none";
        }
    });
});
